import { toast } from "react-toastify";

const VERSION_URL = "/version.json";
const TOAST_ID = "app-update-available";
const POLL_INTERVAL_MS = 10 * 60 * 1000;
const MIN_CHECK_GAP_MS = 60 * 1000;

let started = false;
let baselineVersion: string | null = null;
let lastCheckAt = 0;

function runningBundleVersion(): string | null {
  const script = document.querySelector<HTMLScriptElement>(
    'script[src*="/static/js/main."]'
  );
  const m = script && script.src.match(/main\.[^/]+\.js/);
  return m ? m[0] : null;
}

async function purgeCachesAndReload(): Promise<void> {
  try {
    if ("caches" in window) {
      const names = await window.caches.keys();
      await Promise.all(names.map((n) => window.caches.delete(n)));
    }
  } catch {}
  window.location.reload();
}

async function fetchVersion(): Promise<string | null> {
  try {
    const res = await fetch(VERSION_URL + "?t=" + Date.now(), { cache: "no-store" });
    if (!res.ok) return null;
    const data = JSON.parse(await res.text());
    return data && (typeof data.version === "string" || typeof data.version === "number")
      ? String(data.version)
      : null;
  } catch {
    return null;
  }
}

function showUpdateToast(): void {
  toast.info(
    <div>
      <div>એપનું નવું વર્ઝન ઉપલબ્ધ છે.</div>
      <button
        type="button"
        onClick={() => void purgeCachesAndReload()}
        style={{ marginTop: 8, padding: "4px 12px", cursor: "pointer" }}
      >
        રિફ્રેશ કરો
      </button>
    </div>,
    { toastId: TOAST_ID, autoClose: false, closeOnClick: false, draggable: false }
  );
}

async function check(): Promise<void> {
  if (document.visibilityState === "hidden") return;
  if (typeof navigator !== "undefined" && navigator.onLine === false) return;
  const now = Date.now();
  if (now - lastCheckAt < MIN_CHECK_GAP_MS) return;
  lastCheckAt = now;

  const fetched = await fetchVersion();
  if (fetched === null) return;
  if (baselineVersion === null) {
    baselineVersion = runningBundleVersion() || fetched;
  }
  if (fetched !== baselineVersion) showUpdateToast();
}

export function initUpdateCheck(): void {
  if (started) return;
  if (process.env.NODE_ENV !== "production") return;
  if (typeof window === "undefined" || typeof window.fetch !== "function") return;
  started = true;

  const trigger = () => {
    void check();
  };
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") trigger();
  });
  window.addEventListener("focus", trigger);
  window.addEventListener("pageshow", (e) => {
    if (e.persisted) trigger();
  });
  window.setInterval(trigger, POLL_INTERVAL_MS);
  trigger();
}
